import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const {
    login,
    isOnboarded
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Please enter your email and password.');
      return;
    }
    login(email);
    if (isOnboarded) {
      navigate('/app');
    } else {
      navigate('/onboarding/welcome');
    }
  };
  return <div className="min-h-screen bg-aliceBlue flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-454">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center" data-id="element-455">
        <Link to="/" data-id="element-456">
          <img src="https://cdn.magicpatterns.com/uploads/u4AKTM42BTBGHrLv1PiYxT/Logo_3.png" alt="LawVo" className="h-10 object-contain mx-auto mb-8" data-id="element-457" />
        </Link>
        <h2 className="text-3xl font-bold text-primary" data-id="element-458">Welcome back</h2>
        <p className="mt-3 text-secondary" data-id="element-459">
          Log in to continue your Legal Health Check.
        </p>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-460">
        <div className="bg-white py-8 px-6 shadow-sm sm:rounded-xl sm:px-10 border border-borderColor" data-id="element-461">
          <form className="space-y-5" onSubmit={handleSubmit} noValidate data-id="element-462">
            {error && <div className="p-3 rounded-lg bg-destructive/10 border border-destructive/20" data-id="element-463">
                <p className="text-sm text-destructive font-medium" data-id="element-464">{error}</p>
              </div>}

            <div data-id="element-465">
              <label className="block text-sm font-medium text-primary mb-1" data-id="element-466">
                Email address
              </label>
              <input type="email" required value={email} onChange={e => {
              setEmail(e.target.value);
              setError('');
            }} className="w-full px-4 py-3 rounded-lg border border-borderColor focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none transition-all" placeholder="you@example.com" data-id="element-467" />
            </div>

            <div data-id="element-468">
              <div className="flex items-center justify-between mb-1" data-id="element-469">
                <label className="block text-sm font-medium text-primary" data-id="element-470">
                  Password
                </label>
                <Link to="/forgot-password" className="text-sm font-semibold text-violetBlue hover:text-primary transition-colors" data-id="element-471">
                  Forgot password?
                </Link>
              </div>
              <div className="relative" data-id="element-472">
                <input type={showPassword ? 'text' : 'password'} required value={password} onChange={e => {
                setPassword(e.target.value);
                setError('');
              }} className="w-full px-4 py-3 pr-12 rounded-lg border border-borderColor focus:ring-2 focus:ring-violetBlue focus:border-violetBlue outline-none transition-all" placeholder="••••••••" data-id="element-473" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-secondary hover:text-primary transition-colors" data-id="element-474">
                  {showPassword ? <EyeOff className="w-5 h-5" data-id="element-475" /> : <Eye className="w-5 h-5" data-id="element-476" />}
                </button>
              </div>
            </div>

            <div className="flex items-center gap-3" data-id="element-477">
              <input id="remember-me" type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="h-4 w-4 rounded border-borderColor text-violetBlue focus:ring-violetBlue" data-id="element-478" />
              <label htmlFor="remember-me" className="text-sm text-primary font-medium" data-id="element-479">
                Remember me
              </label>
            </div>

            <button type="submit" className="w-full flex justify-center py-3.5 px-4 border border-transparent rounded-lg shadow-sm text-sm font-semibold text-white bg-violetBlue hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violetBlue transition-opacity" data-id="element-480">
              Log In
            </button>
          </form>
        </div>

        <p className="mt-6 text-center text-sm text-secondary" data-id="element-481">
          Don't have an account?{' '}
          <Link to="/signup" className="font-semibold text-violetBlue hover:text-primary transition-colors" data-id="element-482">
            Create an account
          </Link>
        </p>
      </motion.div>
    </div>;
}